import { UseMutationOptions } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type UseDisableTriggerMutationArgs = {
  triggerUid: string;
};

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    UseDisableTriggerMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const disableTrigger = ({ triggerUid }: UseDisableTriggerMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/triggers/${triggerUid}/disable`,
  );
};

const useDisableTriggerMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationFn: disableTrigger,
    ...options,
  });
};

export default useDisableTriggerMutation;
